import _ from 'underscore';
import { useState } from 'react';

export function useUserInfo(serverContext) {
  const hasAID = !!(_.get(serverContext, ['CurrentAccount', 'Id']));

  const [userInfo, setUserInfo] = useState({
    firstName: _.get(serverContext, ['Identity', 'FirstName']),
    lastName: _.get(serverContext, ['Identity', 'LastName']),
    email: _.get(serverContext, ['Identity', 'Email']),
  });

  const showUserInfoForm = (hasAID || serverContext.IsExistingUser) ? false :
    !userInfo.firstName || !userInfo.lastName || !userInfo.email;

  return [
    showUserInfoForm,
    userInfo,
    setUserInfo,
  ];
}
